<template>
    <div class="animated fadeIn">
        <div class="card admin">
            <div class="card-header">
                Список внутренних номеров
                <div class="pull-right" style="margin-top: 7px">
                    <button class="btn btn-secondary" :class="{ active: showFilter }" data-toggle="dropdown" href="#" @click.prevent="showFilter = !showFilter">
                        <i class="fa fa-filter"></i> Фильтр
                    </button>
                    <button class="btn btn-primary" @click.prevent="showModal">
                        <i class="fa fa-plus"></i> Добавить внутренний номер
                    </button>
                </div>

                <div v-if="showFilter" class="mt-1">
                    <div class="row col-12">
                        <form @submit.prevent="search" сlass="form-horizontal">
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">Номер телефона</label>
                                <div class="col-md-5">
                                    <input type="text" class="form-control" v-model="params.query">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">Пользователь</label>
                                <div class="col-md-5">
                                    <multiselect
                                            :options="users"
                                            :searchable="true"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Пользователь не выбран"
                                            track-by="id" label="fullname"
                                            @open="loadUsers"
                                            @input="changeUser"
                                            :loading="loadingUsers"
                                    >

                                    </multiselect>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-6"></div>
                </div>
            </div>
            <div class="card-block admin__list">
                <div class="row mb-1 text-muted small">
                    <div class="col-1 d-none d-md-block">Id</div>
                    <div class="col-2">Номер</div>
                    <div class="col-5 col-md-7">Пользователи</div>
                    <div class="col-3 col-md-2">Действие</div>
                </div>
                <loading v-if="loading" message="Загружаем номера..."></loading>
                <div v-else class="row mb-1 admin__list__item admin__list__item_hover-bg-gray" v-for="item in items">
                    <div class="col-1 d-none d-md-block">{{item.id}}</div>
                    <div class="col-2">{{item.number}}</div>
                    <div class="col-5 col-md-7">
                         <span class="badge badge-info" v-for="(user, index) in item.users">
                           <router-link :to="{ name: 'ViewProfile', params: { id: user.id }}">{{user.fullname}}</router-link>
                        </span>
                    </div>
                    <div class="col-2">
                        <loading v-if="blockLoading === item.id" :size="2" :message="false"></loading>
                        <template v-else>
                            <button class="btn btn-primary btn-sm" @click.prevent="editItem(item)">
                                <i class="fa fa-edit"></i> Изменить
                            </button>
                        </template>
                    </div>
                </div>
            </div>
            <div class="card-header">
                <b-pagination class="mb-0" size="md" :total-rows="itemsPage.paginator.total_count" v-model="params.page" :per-page="itemsPage.paginator.limit">
                </b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import getInternalNumbersQuery from './../../../gql/queries/PBX/getInternalNumbers.graphql'
  import getUsers from './../../../gql/queries/getUsersForMultiselect.graphql'
  import { mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  export default {
    computed: {
      items () {
        return this.itemsPage.internalNumbers
      }
    },
    data () {
      return {
        params: {
          page: 1,
          query: '',
          userId: null
        },
        users: [],
        itemsPage: {
          internalNumbers: null,
          paginator: {
            total_count: 10
          }
        },
        blockLoading: false,
        showFilter: false,
        loading: false,
        loadingUsers: false
      }
    },
    name: 'internalNumbers',
    components: {
      Multiselect
    },
    methods: {
      showModal () {
        this.$store.dispatch('setAdminModal', 'addEditInternalNumber')
      },
      editItem (item) {
        this.$store.commit('SET_ADMIN_EDIT_INTERNAL_NUMBER', item)
        this.showModal()
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      }),
      changeUser (user) {
        if (user) {
          this.params.userId = user.id
        } else {
          this.params.userId = null
        }
      },
      /**
       * Подргрузка менеджеров
       * активируется при открытии селекта
       */
      loadUsers () {
        this.loadingUsers = true
        this.$apollo.query({
          query: getUsers
        }).then(result => {
          this.users = result.data.users
          this.loadingUsers = false
        }).catch(error => {
          console.log(error)
          this.loadingUsers = false
        })
      }
    },
    apollo: {
      itemsPage: {
        query: getInternalNumbersQuery,
        variables () {
          return {
            page: this.params.page,
            query: this.params.query,
            userId: this.params.userId
          }
        },
        fetchPolicy: 'network-only',
        watchLoading (isLoading, countModifier) {
          this.loading = isLoading
        },
        update: (data) => {
          return data
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// InternalNumbers.vue?46960fc8